import ApiService, { makeRawApiRequest } from "@/services/Api"

import {
	AttendanceSummary,
	NotifyManagerResponse
} from "@/protocols/attendanceSummary"

import { SECOND_IN_MS } from "@/utils/time"

const AI_ATTENDANCE_SUMMARY_UPSELL_NOTIFICATION_TYPE = "AIAttendanceSummaryUpsell"

type GenerateSummaryInput = {
	forceRegenerate?: boolean
}

type StreamSummaryInput = {
	forceRegenerate?: boolean
	onTextChunk: (textChunk: string) => void
}

class AttendanceProtocolSummaryService {
	async getSummary (inboxChannelChatAttendanceId: number): Promise<AttendanceSummary | null> {
		const response = await ApiService.get<AttendanceSummary>(`/attendance-protocol/${inboxChannelChatAttendanceId}/summary`)

		return response.data ?? null
	}

	async generateSummary (inboxChannelChatAttendanceId: number, input?: GenerateSummaryInput): Promise<AttendanceSummary> {
		const response = await ApiService.post<AttendanceSummary>(`/attendance-protocol/${inboxChannelChatAttendanceId}/summary`, input ?? {})

		return response.data
	}

	async streamSummary (inboxChannelChatAttendanceId: number, input: StreamSummaryInput): Promise<Response> {
		const { forceRegenerate, onTextChunk } = input

		const response = await makeRawApiRequest(`/attendance-protocol/${inboxChannelChatAttendanceId}/summary/stream`, {
			method: "POST",
			body: { forceRegenerate: forceRegenerate ?? false },
			signal: AbortSignal.timeout(30 * SECOND_IN_MS)
		})

		if (response.body) {
			const reader = response.body.getReader()
			const decoder = new TextDecoder("utf-8")

			while (true) {
				const { done, value } = await reader.read()

				if (done) {
					break
				}

				const textChunk = decoder.decode(value, { stream: true })
				onTextChunk(textChunk)
			}
		}

		return response
	}

	async notifyManager (): Promise<NotifyManagerResponse> {
		const response = await ApiService.post<NotifyManagerResponse>("/instance/notify-pending-notification", {
			type: AI_ATTENDANCE_SUMMARY_UPSELL_NOTIFICATION_TYPE
		})

		return response.data
	}
}

export default new AttendanceProtocolSummaryService()
